import {Team} from './team';

export enum ViolationReportType {
  sexual = 0, // 性的表現
  violent = 1, // 暴力的
  harassment = 2, // 不快な内容
  spam = 3, // スパム
  criminal = 4, // 犯罪
  suicide = 5, // 自殺または自傷行為
  hateSpeech = 6, // ヘイトスピーチ
  terrorism = 7, // テロ
  other = 8 // その他
}

export function getViolationReportTypeName(type: ViolationReportType): string {
  switch (type) {
    case ViolationReportType.sexual:
      return '性的表現';
    case ViolationReportType.violent:
      return '暴力的';
    case ViolationReportType.harassment:
      return '不快な内容';
    case ViolationReportType.spam:
      return 'スパム';
    case ViolationReportType.criminal:
      return '犯罪';
    case ViolationReportType.suicide:
      return '自殺または自傷行為';
    case ViolationReportType.hateSpeech:
      return 'ヘイトスピーチ';
    case ViolationReportType.terrorism:
      return 'テロ';
    case ViolationReportType.other:
    default:
      return 'その他';
  }
}

export enum ViolationReportStatus {
  unanswered = 0,
  ignored = 1,
  approved = 2, // FeedItemStatusをreportedにする
}

export enum FeedItemStatus {
  normal = 0,
  reported = 1,
  deleted = 2,
  sending = 3 // アプリでのみ利用
}

export const TeamAdminUserId = -1; // TeamAdmin経由で違反報告がある場合はこの値となる

export interface FeedItemReport {
  uuid: string;
  userId: number; // 報告したユーザー
  userNickname: string; // 報告したユーザーのニックネーム User.nickname
  teamId: number;
  reportType: ViolationReportType;
  reason: string;
  reportStatus: ViolationReportStatus;
  createdAt: number;
  feed: FeedItem;
}

export interface FeedItem {
  userId?: number; // 投稿したユーザー オフィシャルチームオーナーの場合はundefined
  userNickname: string; // 投稿したユーザーのニックネーム User.nickname オフィシャルチームオーナーの場合はチーム名
  parentUuid?: string; // 親投稿のuuid。親の場合はundefined
  title?: string; // 投稿のタイトル。親投稿にだけ存在
  content: string; // 投稿の本文
  photoUrls: string[]; // 画像URL
  status: FeedItemStatus;
}

export interface TeamReport {
  userId: number; // 報告したユーザー
  userNickname: string; // 報告したユーザーのニックネーム User.nickname
  teamId: number;
  reportType: ViolationReportType;
  reason: string;
  reportStatus: ViolationReportStatus;
  createdAt: number;
  team: Team;
}


export interface TeamCoursesReport extends TeamReport {
  course: TeamCourse;
}

export interface TeamCourse {
  uuid: string;
  courseUrl: string;
  name: string;
  detail: string;
  distance: number;
  climbUp?: number;
  climbDown?: number;
  owner?: {
    userId: number;
    nickname: string;
    smallPictureUrl: string;
    runAt: number;
  };
}

export interface CourseGeoJson {
  type: 'FeatureCollection';
  features: [
    {
      type: 'Feature';
      properties: null;
      geometry: {
        type: 'LineString';
        coordinates: [number, number, number?][];  // lng, lat, alt(optional)の順
      };
    },
  ];
}
